var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPdfFile)?_c('a',{attrs:{"href":_vm.fileUrl,"download":""}},[_vm._v(" "+_vm._s(_vm.fileName)+" ")]):_c('span',{staticClass:"cursor-pointer",on:{"click":_vm.onClickFile}},[_vm._v(" "+_vm._s(_vm.fileName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }